import React from 'react';
import 'react-multi-email/style.css';
import PropTypes from 'prop-types';
import {
	Alert,
	Col,
	Modal,
	Row,
} from 'reactstrap';
import { useAsyncCallback } from 'react-async-hook';
import { useTranslation } from 'react-i18next';

import { useAsyncErrorLog } from '../../../lib/hooks';
import { useStudio } from '../Context';
import { ButtonLoading, ButtonPill, ButtonPillOutline } from '../../Button';
import { useActiveStudio } from '../Active/Context';

const LIVE_RECORDING_START_DELAY_SECONDS = 20;

export const StudioGoLiveModal = ({
	isOpen,
	toggle,
}) => {
	const { t } = useTranslation();
	const {
		golive,
		studio,
	} = useStudio();
	const { updateActiveStudio } = useActiveStudio();

	const asyncGoLive = useAsyncCallback(async () => {
		const updatedStudio = await golive(
			new Date(Date.now() + LIVE_RECORDING_START_DELAY_SECONDS * 1000),
		);
		updateActiveStudio(updatedStudio);
		toggle();
	});

	useAsyncErrorLog(asyncGoLive);

	return (
		<Modal
			centered
			contentClassName="border-0 rounded overflow-hidden bg-transparent align-self-center"
			isOpen={isOpen}
			toggle={toggle}
			zIndex={2000}
		>
			<div className="bg-dark shadow-lg">
				<Row className="g-0">
					<Col xs="12" lg="8" className="d-flex mx-auto rounded overflow-hidden p-relative">
						<div className="py-5 mx-auto">
							<h4>{t('GoLive.Modal.startNow')}</h4>
							{!studio.isPublic && (
								<p>{t('GoLive.Modal.studioUpdgradeToPublic')}</p>
							)}
							{asyncGoLive.error && (
								<Alert color="danger">
									{t('Global.error')}
								</Alert>
							)}
							<div className="d-flex justify-content-between w-100">
								<ButtonPillOutline
									onClick={toggle}
									color="secondary"
									className=""
								>
									{t('GoLive.Modal.cancel')}
								</ButtonPillOutline>
								<ButtonLoading
									color="primary"
									component={ButtonPill}
									loading={asyncGoLive.loading}
									onClick={asyncGoLive.execute}
								>
									{t('GoLive.Modal.goLive')}
								</ButtonLoading>
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</Modal>
	);
};

StudioGoLiveModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	toggle: PropTypes.func.isRequired,
};
